/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      name
      active
      trial
      usernames
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      name
      active
      trial
      usernames
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      name
      active
      trial
      usernames
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAssessment = /* GraphQL */ `
  mutation CreateAssessment(
    $input: CreateAssessmentInput!
    $condition: ModelAssessmentConditionInput
  ) {
    createAssessment(input: $input, condition: $condition) {
      id
      name
      description
      contactPerson
      type
      imageKey
      active
      public
      language
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      modules {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAssessment = /* GraphQL */ `
  mutation UpdateAssessment(
    $input: UpdateAssessmentInput!
    $condition: ModelAssessmentConditionInput
  ) {
    updateAssessment(input: $input, condition: $condition) {
      id
      name
      description
      contactPerson
      type
      imageKey
      active
      public
      language
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      modules {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAssessment = /* GraphQL */ `
  mutation DeleteAssessment(
    $input: DeleteAssessmentInput!
    $condition: ModelAssessmentConditionInput
  ) {
    deleteAssessment(input: $input, condition: $condition) {
      id
      name
      description
      contactPerson
      type
      imageKey
      active
      public
      language
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      modules {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAssessmentAssignment = /* GraphQL */ `
  mutation CreateAssessmentAssignment(
    $input: CreateAssessmentAssignmentInput!
    $condition: ModelAssessmentAssignmentConditionInput
  ) {
    createAssessmentAssignment(input: $input, condition: $condition) {
      id
      customerID
      assessmentID
      performAssessments {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      version
      package
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAssessmentAssignment = /* GraphQL */ `
  mutation UpdateAssessmentAssignment(
    $input: UpdateAssessmentAssignmentInput!
    $condition: ModelAssessmentAssignmentConditionInput
  ) {
    updateAssessmentAssignment(input: $input, condition: $condition) {
      id
      customerID
      assessmentID
      performAssessments {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      version
      package
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAssessmentAssignment = /* GraphQL */ `
  mutation DeleteAssessmentAssignment(
    $input: DeleteAssessmentAssignmentInput!
    $condition: ModelAssessmentAssignmentConditionInput
  ) {
    deleteAssessmentAssignment(input: $input, condition: $condition) {
      id
      customerID
      assessmentID
      performAssessments {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      version
      package
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createModule = /* GraphQL */ `
  mutation CreateModule(
    $input: CreateModuleInput!
    $condition: ModelModuleConditionInput
  ) {
    createModule(input: $input, condition: $condition) {
      id
      sortingNumber
      title
      assessmentID
      ownerGroups
      questions {
        nextToken
        __typename
      }
      structuredEntries {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateModule = /* GraphQL */ `
  mutation UpdateModule(
    $input: UpdateModuleInput!
    $condition: ModelModuleConditionInput
  ) {
    updateModule(input: $input, condition: $condition) {
      id
      sortingNumber
      title
      assessmentID
      ownerGroups
      questions {
        nextToken
        __typename
      }
      structuredEntries {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteModule = /* GraphQL */ `
  mutation DeleteModule(
    $input: DeleteModuleInput!
    $condition: ModelModuleConditionInput
  ) {
    deleteModule(input: $input, condition: $condition) {
      id
      sortingNumber
      title
      assessmentID
      ownerGroups
      questions {
        nextToken
        __typename
      }
      structuredEntries {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuestion = /* GraphQL */ `
  mutation CreateQuestion(
    $input: CreateQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    createQuestion(input: $input, condition: $condition) {
      id
      title
      package
      text
      source
      moduleID
      ownerGroups
      requirements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuestion = /* GraphQL */ `
  mutation UpdateQuestion(
    $input: UpdateQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    updateQuestion(input: $input, condition: $condition) {
      id
      title
      package
      text
      source
      moduleID
      ownerGroups
      requirements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuestion = /* GraphQL */ `
  mutation DeleteQuestion(
    $input: DeleteQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    deleteQuestion(input: $input, condition: $condition) {
      id
      title
      package
      text
      source
      moduleID
      ownerGroups
      requirements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRequirement = /* GraphQL */ `
  mutation CreateRequirement(
    $input: CreateRequirementInput!
    $condition: ModelRequirementConditionInput
  ) {
    createRequirement(input: $input, condition: $condition) {
      id
      questionID
      text
      weight
      gradations
      ownerGroups
      recommendations {
        nextToken
        __typename
      }
      requirementAnswers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRequirement = /* GraphQL */ `
  mutation UpdateRequirement(
    $input: UpdateRequirementInput!
    $condition: ModelRequirementConditionInput
  ) {
    updateRequirement(input: $input, condition: $condition) {
      id
      questionID
      text
      weight
      gradations
      ownerGroups
      recommendations {
        nextToken
        __typename
      }
      requirementAnswers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRequirement = /* GraphQL */ `
  mutation DeleteRequirement(
    $input: DeleteRequirementInput!
    $condition: ModelRequirementConditionInput
  ) {
    deleteRequirement(input: $input, condition: $condition) {
      id
      questionID
      text
      weight
      gradations
      ownerGroups
      recommendations {
        nextToken
        __typename
      }
      requirementAnswers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRecommendation = /* GraphQL */ `
  mutation CreateRecommendation(
    $input: CreateRecommendationInput!
    $condition: ModelRecommendationConditionInput
  ) {
    createRecommendation(input: $input, condition: $condition) {
      id
      requirementID
      level
      description
      recommendationText
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRecommendation = /* GraphQL */ `
  mutation UpdateRecommendation(
    $input: UpdateRecommendationInput!
    $condition: ModelRecommendationConditionInput
  ) {
    updateRecommendation(input: $input, condition: $condition) {
      id
      requirementID
      level
      description
      recommendationText
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRecommendation = /* GraphQL */ `
  mutation DeleteRecommendation(
    $input: DeleteRecommendationInput!
    $condition: ModelRecommendationConditionInput
  ) {
    deleteRecommendation(input: $input, condition: $condition) {
      id
      requirementID
      level
      description
      recommendationText
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStructuredEntry = /* GraphQL */ `
  mutation CreateStructuredEntry(
    $input: CreateStructuredEntryInput!
    $condition: ModelStructuredEntryConditionInput
  ) {
    createStructuredEntry(input: $input, condition: $condition) {
      id
      title
      description
      source
      entries {
        impact
        risk
        opportunity
        example
        __typename
      }
      threshold
      moduleID
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStructuredEntry = /* GraphQL */ `
  mutation UpdateStructuredEntry(
    $input: UpdateStructuredEntryInput!
    $condition: ModelStructuredEntryConditionInput
  ) {
    updateStructuredEntry(input: $input, condition: $condition) {
      id
      title
      description
      source
      entries {
        impact
        risk
        opportunity
        example
        __typename
      }
      threshold
      moduleID
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStructuredEntry = /* GraphQL */ `
  mutation DeleteStructuredEntry(
    $input: DeleteStructuredEntryInput!
    $condition: ModelStructuredEntryConditionInput
  ) {
    deleteStructuredEntry(input: $input, condition: $condition) {
      id
      title
      description
      source
      entries {
        impact
        risk
        opportunity
        example
        __typename
      }
      threshold
      moduleID
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPerformAssessment = /* GraphQL */ `
  mutation CreatePerformAssessment(
    $input: CreatePerformAssessmentInput!
    $condition: ModelPerformAssessmentConditionInput
  ) {
    createPerformAssessment(input: $input, condition: $condition) {
      id
      assessmentState
      assessmentAssignmentID
      requirementAnswers {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePerformAssessment = /* GraphQL */ `
  mutation UpdatePerformAssessment(
    $input: UpdatePerformAssessmentInput!
    $condition: ModelPerformAssessmentConditionInput
  ) {
    updatePerformAssessment(input: $input, condition: $condition) {
      id
      assessmentState
      assessmentAssignmentID
      requirementAnswers {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePerformAssessment = /* GraphQL */ `
  mutation DeletePerformAssessment(
    $input: DeletePerformAssessmentInput!
    $condition: ModelPerformAssessmentConditionInput
  ) {
    deletePerformAssessment(input: $input, condition: $condition) {
      id
      assessmentState
      assessmentAssignmentID
      requirementAnswers {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRequirementAnswer = /* GraphQL */ `
  mutation CreateRequirementAnswer(
    $input: CreateRequirementAnswerInput!
    $condition: ModelRequirementAnswerConditionInput
  ) {
    createRequirementAnswer(input: $input, condition: $condition) {
      id
      requirementID
      performedAssessmentID
      selectedLevel
      fulfilled
      irrelevant
      comment
      contactPerson
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRequirementAnswer = /* GraphQL */ `
  mutation UpdateRequirementAnswer(
    $input: UpdateRequirementAnswerInput!
    $condition: ModelRequirementAnswerConditionInput
  ) {
    updateRequirementAnswer(input: $input, condition: $condition) {
      id
      requirementID
      performedAssessmentID
      selectedLevel
      fulfilled
      irrelevant
      comment
      contactPerson
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRequirementAnswer = /* GraphQL */ `
  mutation DeleteRequirementAnswer(
    $input: DeleteRequirementAnswerInput!
    $condition: ModelRequirementAnswerConditionInput
  ) {
    deleteRequirementAnswer(input: $input, condition: $condition) {
      id
      requirementID
      performedAssessmentID
      selectedLevel
      fulfilled
      irrelevant
      comment
      contactPerson
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEvaluation = /* GraphQL */ `
  mutation CreateEvaluation(
    $input: CreateEvaluationInput!
    $condition: ModelEvaluationConditionInput
  ) {
    createEvaluation(input: $input, condition: $condition) {
      id
      introText
      performedAssessmentID
      assessmentAssignmentID
      evaluationModuleData {
        nextToken
        __typename
      }
      state
      language
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEvaluation = /* GraphQL */ `
  mutation UpdateEvaluation(
    $input: UpdateEvaluationInput!
    $condition: ModelEvaluationConditionInput
  ) {
    updateEvaluation(input: $input, condition: $condition) {
      id
      introText
      performedAssessmentID
      assessmentAssignmentID
      evaluationModuleData {
        nextToken
        __typename
      }
      state
      language
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEvaluation = /* GraphQL */ `
  mutation DeleteEvaluation(
    $input: DeleteEvaluationInput!
    $condition: ModelEvaluationConditionInput
  ) {
    deleteEvaluation(input: $input, condition: $condition) {
      id
      introText
      performedAssessmentID
      assessmentAssignmentID
      evaluationModuleData {
        nextToken
        __typename
      }
      state
      language
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEvaluationModuleData = /* GraphQL */ `
  mutation CreateEvaluationModuleData(
    $input: CreateEvaluationModuleDataInput!
    $condition: ModelEvaluationModuleDataConditionInput
  ) {
    createEvaluationModuleData(input: $input, condition: $condition) {
      id
      relatedEvaluationId
      moduleID
      resultText
      rating
      maxRating
      questionRating {
        questionID
        rating
        maxRating
        hasAnswer
        __typename
      }
      completelyAnswered
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEvaluationModuleData = /* GraphQL */ `
  mutation UpdateEvaluationModuleData(
    $input: UpdateEvaluationModuleDataInput!
    $condition: ModelEvaluationModuleDataConditionInput
  ) {
    updateEvaluationModuleData(input: $input, condition: $condition) {
      id
      relatedEvaluationId
      moduleID
      resultText
      rating
      maxRating
      questionRating {
        questionID
        rating
        maxRating
        hasAnswer
        __typename
      }
      completelyAnswered
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEvaluationModuleData = /* GraphQL */ `
  mutation DeleteEvaluationModuleData(
    $input: DeleteEvaluationModuleDataInput!
    $condition: ModelEvaluationModuleDataConditionInput
  ) {
    deleteEvaluationModuleData(input: $input, condition: $condition) {
      id
      relatedEvaluationId
      moduleID
      resultText
      rating
      maxRating
      questionRating {
        questionID
        rating
        maxRating
        hasAnswer
        __typename
      }
      completelyAnswered
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPublicAssessmentSubmission = /* GraphQL */ `
  mutation CreatePublicAssessmentSubmission(
    $input: CreatePublicAssessmentSubmissionInput!
    $condition: ModelPublicAssessmentSubmissionConditionInput
  ) {
    createPublicAssessmentSubmission(input: $input, condition: $condition) {
      id
      assessmentID
      customerName
      customerMail
      customerPhone
      customerOrganization
      consentMarketingMails
      preferences
      answerData
      evaluationData
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePublicAssessmentSubmission = /* GraphQL */ `
  mutation UpdatePublicAssessmentSubmission(
    $input: UpdatePublicAssessmentSubmissionInput!
    $condition: ModelPublicAssessmentSubmissionConditionInput
  ) {
    updatePublicAssessmentSubmission(input: $input, condition: $condition) {
      id
      assessmentID
      customerName
      customerMail
      customerPhone
      customerOrganization
      consentMarketingMails
      preferences
      answerData
      evaluationData
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePublicAssessmentSubmission = /* GraphQL */ `
  mutation DeletePublicAssessmentSubmission(
    $input: DeletePublicAssessmentSubmissionInput!
    $condition: ModelPublicAssessmentSubmissionConditionInput
  ) {
    deletePublicAssessmentSubmission(input: $input, condition: $condition) {
      id
      assessmentID
      customerName
      customerMail
      customerPhone
      customerOrganization
      consentMarketingMails
      preferences
      answerData
      evaluationData
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
